import { OutlinedInput } from "@mui/material";
import { forwardRef } from "react";
import { IMaskInput } from "react-imask";

/**
 * NumberMaskedInputBase
 */

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const NumberMaskedInputBase = forwardRef<HTMLInputElement, CustomProps>((props, refs) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      inputRef={refs}
      onAccept={(value: any, { unmaskedValue }: { value: string, unmaskedValue: string }) => {
        if (unmaskedValue.length > 0) {
          onChange({ target: { name: props.name, value } });
        } else {
          onChange({ target: { name: props.name, value: '' } });
        }
      }}
      lazy={false}
      overwrite={true}
      unmask={true}
    />
  );
});

/**
 * CustomNumberMaskedInput
 */

type Props = {
  value: number | null,
  readOnly?: boolean;
  onChange: (value: number | null) => void,
};

export const CustomNumberMaskedInput = ({
  value,
  readOnly,
  onChange,
}: Props) => {
  return (
    <OutlinedInput
      size="small"
      value={value !== null && !isNaN(value) ? (Math.round((value + Number.EPSILON) * 100)).toString() : ''}
      notched={true}
      fullWidth={true}
      readOnly={readOnly}
      onChange={e => {
        if (!readOnly) {
          if (e.target.value !== null && e.target.value.length > 0 && !isNaN(Number(e.target.value))) {
            onChange(Number(e.target.value) / 100);
          } else {
            onChange(null);
          }
        }
      }}
      inputComponent={NumberMaskedInputBase as any}
      inputProps={{
        style: {
          padding: '.2rem .5rem',
        },
        mask: [
          { mask: '[#]\\0,\\00', definitions: { '#': /[-]/ } },
          { mask: '[#]\\0,00', definitions: { '#': /[-]/ } },
          { mask: '[#]0,00', definitions: { '#': /[-]/ } },
          { mask: '[#]00,00', definitions: { '#': /[-]/ } },
          { mask: '[#]000,00', definitions: { '#': /[-]/ } },
          { mask: '[#]0.000,00', definitions: { '#': /[-]/ } },
          { mask: '[#]00.000,00', definitions: { '#': /[-]/ } },
          { mask: '[#]000.000,00', definitions: { '#': /[-]/ } },
          { mask: '[#]0.000.000,00', definitions: { '#': /[-]/ } },
        ],
        placeholder: "_.___.___,__",
      }} />
  );
}